export default __webpack_public_path__ + "static/media/creativity.a52b4e0f.svg";